(function () {
  var STAR = "0,-1 0.247,-0.34 0.951,-0.309 0.399,0.13 0.588,0.809 0,0.42 -0.588,0.809 -0.399,0.13 -0.951,-0.309 -0.247,-0.34";

  function euFlag() {
    var pos = [[15,4.8],[17.6,5.497],[19.503,7.4],[20.2,10],[19.503,12.6],[17.6,14.503],
               [15,15.2],[12.4,14.503],[10.497,12.6],[9.8,10],[10.497,7.4],[12.4,5.497]];
    var stars = pos.map(function (p) {
      return '<polygon points="' + STAR + '" transform="translate(' + p[0] + ',' + p[1] + ') scale(0.95)" fill="#FFCC00"/>';
    }).join('');
    return '<svg viewBox="0 0 30 20" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg"><rect width="30" height="20" fill="#003399"/>' + stars + '</svg>';
  }
  function nordicCross(bg, cross) {
    return '<svg viewBox="0 0 30 20" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg"><rect width="30" height="20" fill="' + bg + '"/><rect x="9" y="0" width="4" height="20" fill="' + cross + '"/><rect x="0" y="8" width="30" height="4" fill="' + cross + '"/></svg>';
  }
  function vStripes(colors) {
    var w = 30 / colors.length;
    var rects = colors.map(function (c, i) { return '<rect x="' + (i * w) + '" y="0" width="' + w + '" height="20" fill="' + c + '"/>'; }).join('');
    return '<svg viewBox="0 0 30 20" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">' + rects + '</svg>';
  }
  function hStripes(colors) {
    var h = 20 / colors.length;
    var rects = colors.map(function (c, i) { return '<rect x="0" y="' + (i * h) + '" width="30" height="' + h + '" fill="' + c + '"/>'; }).join('');
    return '<svg viewBox="0 0 30 20" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">' + rects + '</svg>';
  }
  function spainFlag() {
    return '<svg viewBox="0 0 30 20" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg"><rect width="30" height="20" fill="#AA151B"/><rect y="5" width="30" height="10" fill="#F1BF00"/></svg>';
  }

  var COUNTRIES = [
    { id: 'eu',      label: 'Europe',  name: 'EUROPE',  eyebrow: 'Continental edition', accent: '#2451A4', flag: euFlag(), collectionHandle: 'mega-make-europe-great-again-collection' },
    { id: 'suomi',   label: 'Finland', name: 'FINLAND', eyebrow: 'Finland edition',      accent: '#002F6C', flag: nordicCross('#FFFFFF', '#002F6C'), collectionHandle: 'mfga-make-finland-great-again' },
    { id: 'sverige', label: 'Sweden',  name: 'SWEDEN',  eyebrow: 'Sweden edition',       accent: '#006AA7', flag: nordicCross('#006AA7', '#FECC00'), collectionHandle: 'msga-make-sweden-great-again-collection' },
    { id: 'eesti',   label: 'Estonia', name: 'ESTONIA', eyebrow: 'Estonia edition',      accent: '#0072CE', flag: hStripes(['#0072CE', '#000000', '#FFFFFF']), collectionHandle: 'make-estonia-great-again-collection' },
    { id: 'denmark', label: 'Denmark', name: 'DENMARK', eyebrow: 'Denmark edition',      accent: '#C60C30', flag: nordicCross('#C60C30', '#FFFFFF'), collectionHandle: 'make-denmark-great-again-collection' },
    { id: 'france',  label: 'France',  name: 'FRANCE',  eyebrow: 'France edition',       accent: '#0055A4', flag: vStripes(['#0055A4', '#FFFFFF', '#EF4135']), collectionHandle: 'make-france-great-again-collection' },
    { id: 'spain',   label: 'Spain',   name: 'SPAIN',   eyebrow: 'Spain edition',        accent: '#AA151B', flag: spainFlag(), collectionHandle: 'make-spain-great-again-collection' },
    { id: 'germany', label: 'Germany', name: 'GERMANY', eyebrow: 'Germany edition',      accent: '#DD0000', flag: hStripes(['#000000', '#DD0000', '#FFCE00']), collectionHandle: 'make-germany-great-again-collection' },
    { id: 'ukraine', label: 'Ukraine', name: 'UKRAINE', eyebrow: 'Ukraine edition',      accent: '#0057B7', flag: hStripes(['#0057B7', '#FFD700']), collectionHandle: 'make-ukraine-great-again-collection' }
  ];

  var current = COUNTRIES.filter(function (c) { return c.id === 'eu'; })[0] || COUNTRIES[0];
  var root = document.documentElement;

  function findCountry(id) {
    var match = COUNTRIES.filter(function (c) { return c.id === id; });
    return match[0] || COUNTRIES[0];
  }

  function applyTheme(c) {
    root.style.setProperty('--c1', c.accent);
    setText('heroEyebrow', c.eyebrow);
    setText('heroAccent', c.name);
    setHTML('heroEmblemMedia', c.flag);
    setHTML('brandFlagMedia', c.flag);
    setHTML('footerFlagMedia', c.flag);
    setText('shopTitle', (c.id === 'eu' ? 'Europe' : c.label) + ' collection');
  }
  function setText(id, val) { var el = document.getElementById(id); if (el) el.textContent = val; }
  function setHTML(id, val) { var el = document.getElementById(id); if (el) el.innerHTML = val; }

  function onHomeGrid() {
    return !!document.getElementById('productGrid');
  }

  function renderFlags() {
    var row = document.getElementById('flagRow');
    if (!row) return;
    row.querySelectorAll('.flag-chip').forEach(function (chip) {
      var c = findCountry(chip.getAttribute('data-country-id'));
      var media = chip.querySelector('.flag-media');
      if (media && !media.firstChild) media.innerHTML = c.flag;
      if (c.id === current.id) chip.classList.add('active'); else chip.classList.remove('active');
      if (!chip.getAttribute('data-bound')) {
        chip.setAttribute('data-bound', '1');
        chip.addEventListener('click', function (e) {
          // On the home page the grid is filtered in place; everywhere else the real link is followed.
          if (onHomeGrid()) {
            e.preventDefault();
            current = c;
            renderFlags();
            applyTheme(c);
            filterProducts();
          }
        });
      }
    });
  }

  function initFlagScroller() {
    var scroller = document.getElementById('flagScroller');
    var row = document.getElementById('flagRow');
    if (!scroller || !row) return;
    var prev = scroller.querySelector('.flag-arrow-prev');
    var next = scroller.querySelector('.flag-arrow-next');

    function update() {
      var max = row.scrollWidth - row.clientWidth;
      var scrollable = max > 4;
      if (scrollable && row.scrollLeft > 4) scroller.classList.add('can-prev'); else scroller.classList.remove('can-prev');
      if (scrollable && row.scrollLeft < max - 4) scroller.classList.add('can-next'); else scroller.classList.remove('can-next');
    }
    function step(dir) {
      var amount = dir * Math.max(120, row.clientWidth * 0.6);
      if (row.scrollBy) { row.scrollBy({ left: amount, behavior: 'smooth' }); } else { row.scrollLeft += amount; }
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);

    // Bring the selected country into view (e.g. Ukraine or Germany on a narrow screen)
    var active = row.querySelector('.flag-chip.active');
    if (active) row.scrollLeft = Math.max(0, active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2);
    update();
  }

  function decorateProductCards() {
    document.querySelectorAll('.card[data-country]').forEach(function (card) {
      var c = findCountry(card.getAttribute('data-country'));
      var badge = card.querySelector('[data-flag-badge]');
      if (badge) badge.innerHTML = c.flag;
      var bgSlot = card.querySelector('[data-flag-slot]');
      if (bgSlot) bgSlot.innerHTML = c.flag;
      var slogan = card.querySelector('[data-slogan-slot]');
      if (slogan) slogan.innerHTML = (c.id === 'eu' ? 'MAKE EUROPE' : 'MAKE ' + c.name) + '<br>GREAT AGAIN';
    });
  }

  function filterProducts() {
    document.querySelectorAll('.card[data-country]').forEach(function (card) {
      var id = card.getAttribute('data-country');
      var visible = id === current.id;
      card.style.display = visible ? '' : 'none';
    });
  }

  function renderFooterNations() {
    var ul = document.getElementById('footerNations');
    if (!ul) return;
    ul.innerHTML = '';
    COUNTRIES.filter(function (c) { return c.id !== 'eu'; }).forEach(function (c) {
      var li = document.createElement('li');
      var href = c.collectionHandle ? '/collections/' + c.collectionHandle : '#shop';
      li.innerHTML = '<a href="' + href + '"><span class="flag-media">' + c.flag + '</span>' + c.label + '</a>';
      li.querySelector('a').addEventListener('click', function (e) {
        if (onHomeGrid()) {
          e.preventDefault();
          current = c;
          renderFlags();
          applyTheme(c);
          filterProducts();
          var shop = document.getElementById('shop');
          if (shop) shop.scrollIntoView({ behavior: 'smooth' });
        }
        // else: let the link navigate normally to the collection page
      });
      ul.appendChild(li);
    });
  }

  // ---- Real Shopify cart (AJAX Cart API) ----
  var currencySymbol = (document.body && document.body.getAttribute('data-currency')) || '\u20ac';
  function formatMoney(cents) { return currencySymbol + (cents / 100).toFixed(2); }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function (e) { console.error('Cart fetch failed', e); });
  }

  function renderCart(cart) {
    var countEl = document.getElementById('cartCount');
    if (countEl) countEl.textContent = cart.item_count;
    var itemsEl = document.getElementById('cartItems');
    if (itemsEl) {
      if (!cart.items || cart.items.length === 0) {
        itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
      } else {
        itemsEl.innerHTML = cart.items.map(function (item) {
          var img = item.image ? '<img src="' + item.image + '" alt="" style="width:100%;height:100%;object-fit:contain;display:block;">' : '';
          return '<div class="cart-row">' +
            '<span class="flag-media" style="overflow:hidden;">' + img + '</span>' +
            '<div class="info">' +
              '<div class="n">' + item.product_title + '</div>' +
              '<div class="c">' + item.quantity + ' x ' + formatMoney(item.price) + '</div>' +
              '<button class="rm" data-key="' + item.key + '">Remove</button>' +
            '</div></div>';
        }).join('');
        itemsEl.querySelectorAll('.rm').forEach(function (btn) {
          btn.addEventListener('click', function () { changeItem(btn.getAttribute('data-key'), 0); });
        });
      }
    }
    var subtotalEl = document.getElementById('cartSubtotal');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  function changeItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshCart).catch(function (e) { console.error(e); });
  }

  function openCart() {
    var d = document.getElementById('cartDrawer'); var s = document.getElementById('scrim');
    if (d) d.classList.add('open');
    if (s) s.classList.add('open');
  }
  function closeCart() {
    var d = document.getElementById('cartDrawer'); var s = document.getElementById('scrim');
    if (d) d.classList.remove('open');
    if (s) s.classList.remove('open');
  }

  var toastTimer;
  function showToast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  function interceptProductForms() {
    document.body.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form')) return;
      if (!form.querySelector('input[name="id"], select[name="id"]')) return;
      if (!/\/cart\/add/.test(form.action)) return;
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            showToast(data.description || 'Could not add that item.');
            return;
          }
          refreshCart();
          openCart();
          showToast('Added to cart');
        })
        .catch(function (err) { console.error(err); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var flagRow = document.getElementById('flagRow');
    if (flagRow && flagRow.getAttribute('data-current')) {
      current = findCountry(flagRow.getAttribute('data-current'));
    }
    renderFlags();
    initFlagScroller();
    applyTheme(current);
    decorateProductCards();
    filterProducts();
    renderFooterNations();
    refreshCart();
    interceptProductForms();

    var openBtn = document.getElementById('cartOpenBtn');
    if (openBtn) openBtn.addEventListener('click', openCart);
    var closeBtn = document.getElementById('cartCloseBtn');
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    var scrim = document.getElementById('scrim');
    if (scrim) scrim.addEventListener('click', closeCart);
  });
})();
